import { gql } from '@apollo/client';

export const LIST_ACQUIRER = gql`
  query listAcquirer($input: ListAcquirerInput!) {
    listAcquirer(listAcquirerInput: $input) {
      page
      limit
      total
      totalPage
      acquirers {
        id
        name
        createdAt
        updatedAt
      }
    }
  }
`;

export const DETAIL_ACQUIRER = gql`
  query detailAcquirer($id: String!) {
    detailAcquirer(id: $id) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
